import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './Field.less';

const {
	'field': field_class,
	'field__label': label_class,
	'field__box': box_class,
	'wide': wide_class,
	'bold': bold_class,
	'hint': hint_class,
	'required-star': required_star_class,
} = styles;

export default class Field extends Component {
	render() {
		const {label, children, className, hint, wide, bold, fieldClass, labelClass, required, ...props} = this.props;

		const classes = [field_class];
		const label_classes = [label_class];
		const box_classes = [box_class];

		if (className) {
			classes.push(className);
		}

		if (wide) {
			classes.push(wide_class);
		}

		if (bold) {
			label_classes.push(bold_class)
		}

		if (labelClass) {
			label_classes.push(labelClass);
		}

		if (fieldClass) {
			box_classes.push(fieldClass);
		}

		return (
			<div className={classes.join(' ')} {...props}>
				<div className={label_classes.join(' ')}>
					{label}
					{
						required ? (
							<span className={required_star_class} title='Обязательное поле'>*</span>
						) : (null)
					}

					{
						hint ? (
							<div className={hint_class}>{hint}</div>
						) : (null)
					}
				</div>
				<div className={box_classes.join(' ')}>{children}</div>
			</div>
		);
	}
}

Field.propTypes = {
	label: PropTypes.any
};
